import { createSlice } from "@reduxjs/toolkit";
import {
  getPenStudyFlow,
  createPenStudyFlow,
  updatePenStudyFlow,
  deletePenStudyFlow,
  clearLocalActivePenStudyFlow
} from './actions';

const initialState = {
  penStudyFlow: { 
    id: '', 
    before_in: '', 
    start_at: '', 
    time_zone: '',
    prompt: '',
    upload: false, 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'penStudyFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getPenStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPenStudyFlow.fulfilled, (state, action) => {
        const { pen_study_flow } = action.payload;
        const penStudyFlow = { ...state.penStudyFlow, ...pen_study_flow };
        
        state.loading = false;
        state.penStudyFlow = penStudyFlow;
      })
      .addCase(getPenStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createPenStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPenStudyFlow.fulfilled, (state, action) => {
        const { pen_study_flow } = action.payload;
        
        state.loading = false;
        state.penStudyFlow = pen_study_flow;       
      })
      .addCase(createPenStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updatePenStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePenStudyFlow.fulfilled, (state, action) => {
        const { status, pen_study_flow } = action.payload;
        const updatedPenStudyFlow = { ...state.penStudyFlow, ...pen_study_flow };
        
        state.loading = false;
        if (status === 204) state.penStudyFlow = updatedPenStudyFlow;       
      })
      .addCase(updatePenStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deletePenStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePenStudyFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.penStudyFlow = initialState.penStudyFlow;       
      })
      .addCase(deletePenStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActivePenStudyFlow, state => {
        state.penStudyFlow = initialState.penStudyFlow;
      })
  }
})

export default slice.reducer;